import Rollbar from "rollbar";

export interface RollbarService {
  userLoggedOut(): void;
  userLoggedIn(id: string, email: string, name: string): void;
  error(error: object, customData?: object): void;
}

const ROLLBAR_IGNORED_MESSAGES = [
  "already handled",
  "Failed to fetch",
  "ResizeObserver loop completed with undelivered notifications",
];

const ROLLBAR_CONFIG = {
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  ignoredMessages: ROLLBAR_IGNORED_MESSAGES,
  hostSafeList: [import.meta.env.VITE_ROLLBAR_ALLOWED_HOST],
  payload: {
    environment: import.meta.env.VITE_ROLLBAR_ENVIRONMENT,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: import.meta.env.VITE_CODE_VERSION,
      },
    },
  },
};

export class ProductionRollbarService implements RollbarService {
  private rollbar: Rollbar;

  constructor() {
    this.rollbar = new Rollbar(ROLLBAR_CONFIG);
  }

  userLoggedOut() {
    this.rollbar.configure({ payload: { person: undefined } });
  }

  userLoggedIn(id: string, email: string, name: string) {
    this.rollbar.configure({ payload: { person: { email, id, username: name } } });
  }

  error(error: object, customData?: object) {
    this.rollbar.error(error, customData);
  }
}

export class NullRollbarService implements RollbarService {
  userLoggedOut() {
    console.log("Track user log out");
  }

  userLoggedIn(id: string, email: string, name: string) {
    console.log("Track user log in", id, email, name);
  }

  error(error: object, customData?: object) {
    console.error("Track Error:", error, customData);
  }
}
